// Schema.org structured data for Ekalsutra School Management ERP

export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Ekalsutra Edtech Private Limited",
  "alternateName": "Ekalsutra",
  "url": "https://ekalsutra.com",
  "logo": "https://ekalsutra.com/landingPage/Ekalsutra_Logo.svg",
  "description": "Leading school management ERP software provider in India, offering comprehensive solutions for school administration, fee management, attendance tracking, and mobile apps.",
  "foundingDate": "2019",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Sultanpur",
    "addressRegion": "Uttar Pradesh",
    "addressCountry": "India"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91-9935225294",
    "contactType": "customer service",
    "areaServed": "IN",
    "availableLanguage": ["Hindi", "English"]
  },
  "sameAs": [
    "https://twitter.com/EkalSutra",
    "https://www.linkedin.com/company/ekalsutraofficial/",
    "https://www.facebook.com/profile.php?id=61550863788250",
    "https://www.instagram.com/ekalsutra_official/",
    "https://www.youtube.com/@EkalSutraOfficial"
  ]
});

export const getSoftwareApplicationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Ekalsutra School Management ERP",
  "description": "Comprehensive school management software with 11+ modules including fee management, attendance tracking, admission management, academic details, and mobile applications for parents and staff.",
  "applicationCategory": "EducationApplication",
  "operatingSystem": ["Web Browser", "Android", "iOS"],
  "url": "https://ekalsutra.com",
  "screenshot": "https://ekalsutra.com/landingPage/homeImg.svg",
  "softwareVersion": "2.0",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "price": "Contact for pricing",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "seller": {
      "@type": "Organization",
      "name": "Ekalsutra Edtech Private Limited"
    }
  },
  "provider": {
    "@type": "Organization",
    "name": "Ekalsutra Edtech Private Limited",
    "url": "https://ekalsutra.com"
  },
  "featureList": [
    "Fee Management System",
    "Attendance Tracking",
    "Admission Management",
    "Academic Management",
    "Transport Management",
    "Library Management",
    "Examination Management",
    "Student Information System",
    "Parent Communication Portal",
    "Staff Management",
    "Mobile Applications",
    "Website Builder"
  ]
});

export const getWebPageSchema = (pageName, description) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": pageName,
  "description": description,
  "url": `https://ekalsutra.com${pageName === 'Home' ? '' : '/' + pageName.toLowerCase().replace(/\s+/g, '-')}`,
  "mainEntity": {
    "@type": "SoftwareApplication",
    "name": "Ekalsutra School Management ERP"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Ekalsutra Edtech Private Limited",
    "logo": {
      "@type": "ImageObject",
      "url": "https://ekalsutra.com/landingPage/Ekalsutra_Logo.svg"
    }
  }
});

export const getBreadcrumbSchema = (breadcrumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((breadcrumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": breadcrumb.name,
    "item": `https://ekalsutra.com${breadcrumb.url}`
  }))
});

export const getFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const getServiceSchema = (serviceName, description) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": serviceName,
  "description": description,
  "provider": {
    "@type": "Organization",
    "name": "Ekalsutra Edtech Private Limited",
    "url": "https://ekalsutra.com"
  },
  "areaServed": {
    "@type": "Country",
    "name": "India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "School Management Software Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "School ERP Implementation"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Training and Support"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Data Migration"
        }
      }
    ]
  }
});

export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Ekalsutra Edtech Private Limited",
  "image": "https://ekalsutra.com/landingPage/Ekalsutra_Logo.svg",
  "telephone": "+91-9935225294",
  "email": "info@ekalsutra.com",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Sultanpur",
    "addressRegion": "Uttar Pradesh",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "26.2124007",
    "longitude": "82.0736999"
  },
  "url": "https://ekalsutra.com",
  "priceRange": "Contact for pricing",
  "openingHours": "Mo-Sa 09:00-18:00"
});
